<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 col-xlg-3 col-md-5">
                <div class="card">
                    <div class="card-body text-center">
                        <div class="profile-pic m-b-20 m-t-20">
                            <blockie :address="this.currentUser.email" style="width: 150px"></blockie>
                            <!--<img src="../../../assets/images/users/1.jpg" width="150" class="rounded-circle" alt="user"/>-->
                            <h4 class="m-t-20 m-b-0">{{user.first_name}}&nbsp;{{user.last_name}}</h4>
                            <a href="mailto:danielkristeen@gmail.com">{{user.email}}</a>
                        </div>
                    </div>
                    <div class="p-25 border-top m-t-15">
                        <div class="row text-center">
                            <div class="col-6 border-right">
                                <router-link :to="{ name: 'editprofile'}" class="link d-flex align-items-center justify-content-center font-medium">
                                    <i class="mdi mdi-account font-20 m-r-5"></i>&nbsp;Edit Profile
                                </router-link>
                            </div>
                            <div class="col-6">
                                <router-link :to="{name: 'wallet'}" class="link d-flex align-items-center justify-content-center font-medium">
                                    <i class="mdi mdi-bank font-20 m-r-5"></i>&nbsp;Banking
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-8 col-xlg-9 col-md-7">
                <div class="card card-blue">
                    <div class="card-header">
                        <h4 class="card-title">Your Profile</h4>
                        <h6 class="card-subtitle">
                            Please keep your profile information always current in order to help you when you contact us.
                        </h6>
                    </div>
                    <div class="card-body">
                        <h4 class="card-title mb-4">Personal Info</h4>
                        <div class="row">
                            <div class="col-md-3  text-right">
                                <label class="control-label">First Name:</label>
                            </div>
                            <div class="col-md-9">
                                <p class="form-control-static"> {{user.first_name}} </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3  text-right">
                                <label class="control-label">Last Name:</label>
                            </div>
                            <div class="col-md-9">
                                <p class="form-control-static"> {{user.last_name}} </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3 text-right">
                                <label class="control-label">Email:</label>
                            </div>
                            <div class="col-md-9">
                                <p class="form-control-static"> {{user.email}} </p>
                            </div>
                        </div>

                        <hr>

                        <h4 class="card-title mb-4">Address</h4>
                        <div class="row">
                            <div class="col-md-3 text-right">
                                <label class="control-label">Address:</label>
                            </div>
                            <div class="col-md-9">
                                <p class="form-control-static">{{user.line1}}{{', '+user.line2}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3 text-right">
                                <label class="control-label">City:</label>
                            </div>
                            <div class="col-md-9">
                                <p class="form-control-static">{{user.city}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3 text-right">
                                <label class="control-label">State:</label>
                            </div>
                            <div class="col-md-9">
                                <p class="form-control-static">{{user.state}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3 text-right">
                                <label class="control-label">Postal Code:</label>
                            </div>
                            <div class="col-md-9">
                                <p class="form-control-static">{{user.postal_code}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3 text-right">
                                <label class="control-label">Country:</label>
                            </div>
                            <div class="col-md-9">
                                <p class="form-control-static">{{user.country}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="m-b-0 text-right">
                            <router-link :to="{ name: 'editprofile'}" class="btn btn-info">
                                <i class="fa fa-pencil"></i> Edit Profile
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../common/Blockie"

    export default {
        name: "MyProfile",
        computed: {
            ...mapGetters(["currentUser"])
        },
        components: {Blockie},
        data() {
            return {
                user: {},
                address: ''
            }
        },
        mounted() {
            this.getUser();
        },
        methods: {
            async getUser() {
                $(".preloader").fadeIn();
                let reply = await this.$http.get('/account');
                $(".preloader").fadeOut();
                this.user = reply.data;
            }
        }
    }
</script>

<style scoped>

</style>
